module.exports = __webpack_public_path__ + "static/media/img-app-interview-pass.50033741.png";